export default __webpack_public_path__ + "static/media/document.fbb7efda.png";